import React from "react";
import lodash from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col, Button, Tooltip, Card } from "antd";
import { PlusCircleFilled } from "@ant-design/icons";
import { formatNumber } from "../../../../store/utils/format_number/format_number";

const IncomeByStaffList = ({ edit, incomes }) => {
  // -------------------------- VAR --------------------------
  const navigate = useNavigate();
  const params = useParams();
  const shopId = params?.shopId;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // const incomes = useSelector(incomeSelector);
  const staffs = incomes?.staffs || null;
  const sumTotal = renderSumIncome(staffs) || 0;
  const labelSum = formatNumber(sumTotal);

  // -------------------------- FUNCTION --------------------------
  const handleStaff = () => {
    const href = `/report/cashup/${shopId}/income-by-staff/detail`;
    navigate(href);
  };
  const sortData = (data) => {
    const sort = data
      ?.slice()
      .sort(
        (a, b) =>
          lodash.sumBy(b.income, (i) => i?.value) -
          lodash.sumBy(a.income, (i) => i?.value)
      );
    return sort;
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  const renderList = () => {
    const refineData = sortData(staffs);
    if (staffs?.length > 0) {
      return (
        <Row>
          {refineData?.map((item, index) => {
            const income = item?.income;
            const total = lodash.sumBy(income, (i) => i?.value);
            const fullName = item?.fullName;
            const order = index + 1;
            return renderCardStaff({ total, fullName, order });
          })}
        </Row>
      );
    }

    return <>No staffs income</>;
  };

  const renderCardStaff = ({ total, fullName, order }) => {
    const label = formatNumber(total);
    return (
      <Row key={order} style={{ width: "100%", margin: "6px 0px" }}>
        <Col span={14}>
          {order}. {fullName}
        </Col>
        <Col align="right" span={10}>
          ${label}
        </Col>
      </Row>
    );
  };

  const renderAddIcon = () => {
    return (
      <Row style={{ margin: "10px 0px" }}>
        <Tooltip title="Add Staff">
          <Button
            type="text"
            shape="circle"
            onClick={handleStaff}
            disabled={!edit}
            icon={
              <PlusCircleFilled
                style={{ fontSize: 24, color: edit ? "green" : "gray" }}
              />
            }
          />
        </Tooltip>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------
  const title = (
    <Row style={{ width: "100%" }}>
      <Col span={14}>Income by Staff:</Col>
      <Col align="right" span={10}>
        ${labelSum}
      </Col>
    </Row>
  );
  return (
    <Row span={24} style={{ width: "100%" }}>
      <Col span={24}>
        <Card className="item-card" title={title}>
          <Col span={24}>{renderList()}</Col>
          <Col span={24}>{renderAddIcon()}</Col>
        </Card>
      </Col>
    </Row>
  );
};

export default IncomeByStaffList;

const renderSumIncome = (data) => {
  const totals = data?.map((item) => {
    const income = item?.income;
    const total = lodash.sumBy(income, (r) => r?.value) || 0;
    return total;
  });

  const sum = lodash.sum(totals);
  return sum;
};
